export class GridControl extends HTMLElement {
	constructor() {
		super();
		this.gridElementId = this.getAttribute('grid-element-id');
		this.controlButtons = this.querySelectorAll(
			'[data-ref="controlButton"]'
		);
		this.controlButtonClasses = [];
	}

	connectedCallback() {
		if (!this.gridElementId) {
			console.error(
				'grid-element-id attribute is required for <grid-control>'
			);
			return;
		}

		const gridElement = document.querySelector(`#${this.gridElementId}`);

		if (!gridElement) {
			console.error(`No element found with ID: ${this.gridElementId}`);
			return;
		}

		if (this.controlButtons) {
			this.controlButtonClasses = [...this.controlButtons].map(
				(button) => {
					return button.getAttribute('control-class');
				}
			);
		}

		this.gridElement = gridElement;

		// Initialize grid control
		this.initGridControl();
	}

	initGridControl() {
		for (const button of this.controlButtons) {
			button.addEventListener('click', (event) => {
				const gridClass = button.getAttribute('control-class');
				if (gridClass && this.gridElement) {
					for (const controlClass of this.controlButtonClasses) {
						this.gridElement.classList.remove(controlClass);
					}
					this.gridElement.classList.add(gridClass);
				}
			});
		}
	}
}
